<template lang="pug">
  v-row 
      v-col(cols="12")
        div
          v-toolbar.mx-0.mb-4.rounded-lg(flat)
            v-toolbar-title.title {{$t("config.themes")}}
            v-spacer 
            CreateUpdateThemeDialog(:tenantId="tenantId")
          div
            v-row(v-if="loading")
              v-col(cols='12' sm="6" md="3" v-for='(item, i) in 4' :key='i')
                v-skeleton-loader.rounded-lg.elevation-25.mx-auto.mb-4(ref='skeleton' type='card')
            v-row(v-else)
              v-col(cols="12" sm="6" md="3" v-for="(theme, index) in themes" :key="index")
                v-card.pt-1.rounded-lg(flat)

                  v-responsive(:aspect-ratio="1/1")
                    v-img.mx-4.mt-4.rounded-lg(:src='theme.imageUrl')
                  v-card-title.mb-0(v-text='theme.title')
                  v-card-subtitle.pb-0 {{formatDateTo(theme.updatedAt, 'L')}}

                  v-list(dense)
                    //- v-divider
                    v-list-item(dense)
                      v-list-item-avatar.elevation-2.rounded-lg(size="32" :color="theme.primaryColor")
                      v-list-item-title {{$t("settings.primaryColor")}}
                    //- v-divider
                    v-list-item(dense)
                      v-list-item-avatar.elevation-2.rounded-lg(size="32" :color="theme.accentColor")
                      v-list-item-title {{$t("settings.accentColor")}}
                    //- v-divider
                    v-list-item(dense)
                      v-list-item-avatar.elevation-2.rounded-lg(size="32"  :color="theme.textColor")
                      v-list-item-title {{$t("settings.textColor")}}
                    //- v-divider
                  v-card-actions.px-4.pb-4

                    v-btn(depressed small :color="theme.primaryColor" :dark="!theme.excludeIntro" @click="displayMovie(theme.intro)" :disabled=("theme.excludeIntro"))
                      | Intro
                      v-icon.ml-2(small) mdi-play-circle
                  
                    v-btn(depressed small :color="theme.primaryColor" dark @click="displayMovie(theme.outro)")
                      | Outro
                      v-icon.ml-2(small) mdi-play-circle
                  v-divider(v-if="theme && isSuperAdmin")
                  v-card-actions.px-4(v-if="theme && isSuperAdmin")
                    v-icon {{theme.addAudio ? 'volume_up' : 'volume_off'}}
                    v-spacer
                    CreateUpdateThemeDialog(:theme="theme", :tenantId="tenantId")
              //-v-col(cols="12" v-for="(theme, index) in themes" :key="index")
                v-card.elevation-0.rounded-lg()
                  .d-md-flex.flex-no-wrap.justify-space-between
                    div
                      v-card-title.display-1(v-text='theme.title')
                      //- v-card-subtitle(v-if="index == 0") default
                      v-card-text 
                        //- pre {{theme}}
                      v-card-actions
                        v-container 
                         v-row(dense)
                          v-col
                            v-btn(outlined block @click="displayMovie(theme.intro)" :disabled=("theme.excludeIntro"))
                              | Intro
                              v-icon.ml-2 mdi-play-circle
                          v-col
                            v-btn(outlined block @click="displayMovie(theme.outro)")
                              | Outro
                              v-icon.ml-2 mdi-play-circle
                        v-spacer
                        v-icon(v-if="theme && isSuperAdmin") {{theme.addAudio ? 'volume_up' : 'volume_off'}}
                        CreateUpdateThemeDialog(:theme="theme", :tenantId="tenantId")
                    
                    v-avatar.ma-3(size='125' tile='')
                      v-img(:src='theme.imageUrl')
                      

</template>

<script>
import { mapState } from "vuex";
import UploadThemeFiles from "./UploadThemeFiles";
import date from "@/utils/date";
import CreateUpdateThemeDialog from "@/components/admin/CreateUpdateThemeDialog";
import { VideoElement } from "@/models";
export default {
  name: "ThemeSettings",
  components: {
    UploadThemeFiles,
    CreateUpdateThemeDialog,
  },
  props: ["tenantId"],
  data: () => ({
    loading: true,
  }),
  computed: {
    ...mapState({
      themes: (state) => state.create.themes,
      isSuperAdmin: (state) => state.auth.isSuperAdmin,
    }),
  },
  mounted() {
    this.$store
      .dispatch("create/FETCH_THEMES", this.tenantId)
      .then(() => {
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  },
  methods: {
    ...date,
    displayMovie(item) {
      this.$store.commit("player/set_video_dialog", {
        visible: true,
        src: item,
        type: "video/mp4",
        element: VideoElement.CLIP,
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.videoPlayer
  width: 100% !important
  margin-bottom: -5px
</style>
